define('views/modules/feedback/modal/feedback-modal-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/events/calendar-events',
    'services/events/conversation-events',
    'services/platform.service',
    // src
    'src/views/form-view',
    // views
    'views/modules/feedback/blocks/feeling',
    'views/modules/feedback/blocks/comment',
    'views/modules/feedback/blocks/app-rating',
    // collections
    'collections/member/supervisors',
    'collections/conversation/conversations',
    // templates
    'text!templates/modules/feedback/modal/feedback-modal-form.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // services
    CalendarEvents,
    ConversationEvents,
    PlatformService,
    // src
    VForm,
    // Views
    VFeedbackFeeling,
    VFeedbackComment,
    VFeedbackAppRating,
    // collections
    Supervisors,
    CConversations,
    // Templates
    TFeedbackModalForm
) {

    var VFeedbackModalForm = VForm.extend({
        template: TFeedbackModalForm,
        className: "feedback-modal-form",
        fields: ['feedback_level', 'feedback_comment'],

        regions: {
            root: ".feedback-modal-form",
            feeling: ".feedback-feeling",
            comment: ".feedback-comment",
            doneButton: ".btn-action-done",
            feedbackTitle: "#feedback-title",
            appRating: ".feedback-app-rating"
        },

        initialize: function(opt) {

            var model = this.model,
                conversations = this.conversations = new CConversations(),
                view = this.view = {
                    feeling: new VFeedbackFeeling({ model: model }),
                    comment: new VFeedbackComment({ model: model }),
                    appRating: new VFeedbackAppRating({ model: model }),
                };

            this.listenTo(model, 'change:feedback_level', this.onFeedbackLevelChange);
        },

        render: function() {
            // Render Template HTML with Mustache
            var model = this.model;
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                feedback_level: model.getFeedbackLevel(),
                feedback_title: model.getFeedbackLevelTitle(),
            })));

            // Caching scoped jquery element from 'regions'.
            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.feeling, zone.$feeling)
                .assign(view.comment, zone.$comment)
                .assign(view.appRating, zone.$appRating);

            return this;
        },

        toggleFeedbackLevelClass: function(level) {
            var zone = this.zone,
                buttonZone = zone.$doneButton,
                feedbackTitle = zone.$feedbackTitle;

            buttonZone.removeClassPrefix('level-');
            buttonZone.addClass(Mustache.render('level-{{feedback_level}}', Mustache.getContext({
                feedback_level: level
            })));

            feedbackTitle.removeClassPrefix('level-');
            feedbackTitle.addClass(Mustache.render('level-{{feedback_level}}', Mustache.getContext({
                feedback_level: level
            })));
            return this;
        },

        changeFeedbackLevelTitle: function(value) {
            this.zone.$feedbackTitle.text(this.model.getFeedbackLevelTitle());
        },

        triggerCalendarEvents: function() {
            var model = this.model;
            CalendarEvents.itemUpdate(model.clone());
            CalendarEvents.feedbackModalChange(model.clone());
            return this;
        },

        sendFeedbackToSupervisors: function() {
            var model = this.model;

            if (model.hasComment() && model.getFeedbackComment() !== this.masterCarbon.getFeedbackComment()) {
                Supervisors.each(function(supervisor) {
                    this.conversations.add({
                        message: model.getFeedbackComment(),
                        user: supervisor.id,
                        type: 'feedback',
                        activity: model.id
                    }, { sort: false });
                }, this);

                this.conversations.bulkCreate({
                    success: this.onFeedbackSent,
                    context: this
                });
            }
            return this;
        },

        ////////////
        // events //
        ////////////

        onFeedbackLevelChange: function(model, value) {
            if (!this.zone) return;
            this.toggleFeedbackLevelClass(value);
            this.changeFeedbackLevelTitle(value);
        },

        onFeedbackSent: function(response) {
            this.conversations.reset();
            ConversationEvents.feedbackSentToSupervisors(new CConversations(response.collection, { sort: false }));
        },

        onSubmit: function() {
            var model = this.model;
            if (!model.get('feedback_level')) {
                model.setFeedbackLevel(10);
            }

            // App Review - Request in-app review if rating is high
            if (this.view.appRating.getValue() > 6) {
                if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.AppReview) {
                    window.Capacitor.Plugins.AppReview.requestReview()
                        .then(function() {
                            console.log('In-app review requested successfully');
                        })
                        .catch(function(error) {
                            console.error('Failed to request in-app review:', error);
                        });
                }
            }
        },

        onSuccess: function() {
            this.triggerCalendarEvents()
                .sendFeedbackToSupervisors();
        },

    });

    return VFeedbackModalForm;

});

